import lazyLoading from './lazyLoading'

export default {
  name: 'usersControl',
  system: 'support',
  auth: 'support',
  path: '/users_control',
  meta: {
    auth: true,
    icon: 'fa-users',
    label: 'Users Control',
  },
  component: lazyLoading('usersControl', true)
}
